/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import * as Sentry from '@sentry/browser'

import {
  Button,
  Warning
} from '../'

export class ErrorBoundary extends React.Component {
  static propTypes = {
    errorText: PropTypes.string,  // provides alternate error text to the default
    children: PropTypes.element.isRequired,
    fillOutErrorReport: PropTypes.bool,  // set to true this allows for reporting to be sent to Sentry
    className: PropTypes.string
  }

  state = {
    hasError: false,
    error: null
  }

  static getDerivedStateFromError(error) {
    // update state so the next render will show the fallback UI
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(error, errorInfo)
    } else {
      // bubble up to Sentry’s global uncaught error handler
      Sentry.captureException(error, { extra: errorInfo })
    }
  }

  render() {
    if(this.state.hasError) {
      // render fallback UI
      return (
        <div className={`slds-size_1-of-1${this.props.className ? ` ${this.props.className}` : ''}`}>
          <Warning className='slds-p-around_large'>
            {this.props.errorText
              ? this.props.errorText
              : 'Something went wrong...'
            }
          </Warning>
          {this.props.fillOutErrorReport
            ? <span className='slds-m-left_small'>
                Click&nbsp;
                <Button
                  type='reset'
                  onClick={() => {
                    let lastEventId = Sentry.lastEventId()
                    if (lastEventId) {
                      Sentry.showReportDialog({ eventId: lastEventId })
                    } else {
                      Sentry.showReportDialog()
                    }
                  }}>
                  here
                </Button>
                &nbsp;to fill out report
              </span>
            : null
          }
        </div>
      )
    }
    // when there's not an error, render children untouched
    return this.props.children
  }
}



// WEBPACK FOOTER //
// ./src/components/error-boundary/index.js